import { DateTime } from "luxon"

import { LocalizedStrict } from "../../../../../../../../modules/localization/components/AppLocalized"
import { useDateTime } from "../../../../../../../../modules/localization/useDateTime"

import { DeliveryMessageBox } from "./DeliveryMessageBox"

type BookingDateMismatchMessageProps = Readonly<{
    bookingStart: DateTime
    deliveryDate: DateTime
}>

/**
 * The delivery date is independent of the booking date, so whenever the two drift apart the
 * user has to see it spelled out — the popover otherwise only shows the delivery date and it
 * reads as if catering was booked for the meeting day.
 */
export function BookingDateMismatchMessage({ bookingStart, deliveryDate }: BookingDateMismatchMessageProps) {
    const dateTimeFactory = useDateTime()

    return (
        <LocalizedStrict
            id="create-order-delivery-times-dialog-booking-date-mismatch"
            vars={{
                bookingDate: dateTimeFactory.formatLongDate(bookingStart),
                bookingTime: dateTimeFactory.formatTime(bookingStart),
                deliveryDate: dateTimeFactory.formatLongDate(deliveryDate),
            }}
        >
            <DeliveryMessageBox>
                Your booking is on {dateTimeFactory.formatLongDate(bookingStart)} at{" "}
                {dateTimeFactory.formatTime(bookingStart)}, but the meeting service is on{" "}
                {dateTimeFactory.formatLongDate(deliveryDate)}.
            </DeliveryMessageBox>
        </LocalizedStrict>
    )
}
